import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Card, Button, Progress, Spin } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import './OrganizationUsage.scss'
const OrganizationUsage = memo(({ data, loading, onPurchaseClick }) => {
  const { t } = useTranslation()

  if (!data && !loading) {
    return null
  }

  const { totalCredits, usedCredits, remainingCredits, consumedPercent } = data || {}
  const consumedPercentage = consumedPercent !== undefined
    ? parseFloat(consumedPercent)
    : (totalCredits > 0 ? (usedCredits / totalCredits) * 100 : 0)

  const displayPercentage = typeof consumedPercentage === 'number'
    ? (Number.isInteger(consumedPercentage) ? consumedPercentage : consumedPercentage.toFixed(1))
    : 0

  return (
    <Card className="organization-usage-card">
      <Spin spinning={loading}>
        <div className="organization-usage-content">
          <div className="credits-consumed-section">
            <div className="credits-display">
              <span className="credits-value">
                {usedCredits?.toLocaleString() || 0} of {totalCredits?.toLocaleString() || 0}
              </span>
              <span className="credits-label">Credits consumed so far</span>
            </div>
            <div className="ai-credit-progress-section">
              <Progress
                percent={consumedPercentage}
                strokeColor="#52c41a"
                showInfo={true}
                format={() => `${displayPercentage}% Consumed`}
                className="usage-progress"
              />
            </div>
          </div>
          <div className="credits-remaining-section">
            <div className="remaining-info">
              <span className="remaining-value">
                {remainingCredits?.toLocaleString() || 0}
              </span>
              <span className="remaining-label">Credits remaining</span>
            </div>
            <Button
              type="primary"
              onClick={onPurchaseClick}
              disabled={false}
            >
              <PlusOutlined />Purchase more credits
            </Button>
          </div>
        </div>
      </Spin>
    </Card>
  )
})

OrganizationUsage.propTypes = {
  data: PropTypes.shape({
    totalCredits: PropTypes.number,
    usedCredits: PropTypes.number,
    remainingCredits: PropTypes.number
  }),
  loading: PropTypes.bool,
  onPurchaseClick: PropTypes.func
}

OrganizationUsage.displayName = 'OrganizationUsage'

export default OrganizationUsage
